let timerIsEnded;
let timeout;

const createOnVisibilityChange = (callBack: () => void, timer: number = 60 * 1000) => () => {
  if (document.hidden) {
    timeout = setTimeout(() => (timerIsEnded = true), timer);
  } else if (!timerIsEnded) {
    clearTimeout(timeout);
  } else {
    callBack();
  }
};

export const onChangeActivityPageTimer = (callBack: () => void, timer: number = 60 * 1000) => {
  const handler = createOnVisibilityChange(callBack, timer);
  document.addEventListener('visibilitychange', handler);

  return () => document.removeEventListener('visibilitychange', handler);
};
